import { Component, TemplateRef, ViewChild } from '@angular/core';
import { AlertsvarService } from '../alertsvar.service';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AlertsService } from '../alerts-custom.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { getObjectDiff } from '@donedeal0/superdiff';
import { KeyValue } from '@angular/common';
import { SharedService } from 'src/app/services/shared.service';
import { FormArray, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-de-dup',
  templateUrl: './de-dup.component.html',
  styleUrls: ['./de-dup.component.scss']
})
export class DeDupComponent {

  constructor(
    public alertvarservice : AlertsvarService,
    private alertservice : AlertsService,
    private timezoneservice: TimeZoneService,
    public sharedservice: SharedService,
    public matdialog: MatDialog,
  ){}

  @ViewChild('actionpanel') actionpanel: TemplateRef<any>;

  dialogRef

  refreshDedup:boolean = false;

  setActionInput



  pagenumber = 1
  pagelength = 1

  itemperpage = new FormControl(25);

  selectAll= new FormControl()

  multiSelect=[]

  multi_data={}

  deletedRecordCount:number = 0; 

  mat_fields_spinner = false

  fields=[]

  selected_fields=[]

  $destroy: Subject<boolean> = new Subject();

  dedupReq={
  }

  showApply=true

  dedup_results = []

  bulkMode=false

  active_panel:number

  alert_dedup_data = {
  }

  exemptedGroups=[]

  

ngOnInit(){
  // console.log(this.alertvarservice.dedupId)
// console.log(this.alertvarservice.dedupData)
this.alertvarservice.dedup_time.reset(3600)
this.deletedRecordCount = 0;

  this.getCardinality(this.alertvarservice.dedupData.alertId)

  

//   this.mat_fields_spinner=true
//   setTimeout(() => {
//     this.mat_fields_spinner=false
//     this.fields= this.removeTimeField(this.alertvarservice.mockdedup.fields)
//   }, 500);
}

groupClick(event,group){
  // let baseObj = {"alert_info":{"alertId":this.alertvarservice.dedupData.alertId,"dedup":[]}}
  let baseObj = this.buildActionPostreqObjStruct()
  let check = event.target as HTMLInputElement

// console.log(check.checked)
  if(check.checked){
    group.checked = true

    

    let obj ={"timerange":group.timerange,"fields":group.fields,"status":group.status,"alertCount":group.alertCount}
    if(this.selectAll.value){
      this.exemptedGroups.forEach((dat,index)=>{
        if(getObjectDiff(dat,obj).status == "equal"){
// console.log("Equal ", dat)
          this.exemptedGroups.splice(index,1)
        }
      })
    }else{
      this.multiSelect.push(obj)
    }

// console.log("Exempted =----> ",this.exemptedGroups)
    
  }else{
    let obj ={"timerange":group.timerange,"fields":group.fields,"status":group.status,"alertCount":group.alertCount}
    group.checked = false

    if(this.selectAll.value){
      this.exemptedGroups.push(obj)
    }
    this.multiSelect.forEach((dat,index)=>{
      if(getObjectDiff(dat,obj).status == "equal"){
        this.multiSelect.splice(index,1)
      }
    })
    
    
  }
  baseObj.alert_info.dedup=this.multiSelect
  baseObj.alert_info.exemptedGroups = this.exemptedGroups
  baseObj.alert_info["bulk_action"]=this.selectAll.value ? true : false
  baseObj.alert_info["timerange"]=this.toDate(this.alertvarservice.alertTimeFilter.value)
  baseObj["totalCount"]= this.multiSelect.length ? this.multiSelect.length :this.dedup_results.length
  this.multi_data=baseObj
 
  // console.log(group)
  // console.log(this.multiSelect)
// console.log(this.multi_data)
  if(this.multiSelect.length >= 2 || this.selectAll.value){
    this.bulkMode = true
  }else{
    this.bulkMode = false
  }

// console.log("=----> ",this.getSelectedAlertCount())
}

checkboxCheck(group){
  let obj ={"timerange":group.timerange,"fields":group.fields,"status":group.status}
  let exists = false
  this.multiSelect.forEach((dat,index)=>{
    if(getObjectDiff(dat,obj).status == "equal"){
      exists =true
    }
  })

  return exists
}



removeTimeField(fields){
  let arr=[]
  fields.forEach(val=>{
    if(val.disp == "time"){

    }else{
      arr.push(val)
    }
  })
  return arr
}

async getCardinality(alertId){
  this.mat_fields_spinner = true
  let req = {"alertId":alertId}
  await this.alertservice.fieldsCardinalityGet.postrequest(req).then(val=>{
// console.log(val)
    this.alertvarservice.mockdedup=val
    this.fields= this.removeTimeField(this.alertvarservice.mockdedup.fields)
    this.mat_fields_spinner = false
  }).catch(err=>{
// console.log(err)
    this.mat_fields_spinner = false
  })
}

ngAfterViewInit(){
  this.alertvarservice.dedup_time.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(time=>{
    // console.log(time)
  })

  this.selectAll.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(val=>{
// console.log(val)
// console.log(this.dedup_results)
    if(val == true){
      this.bulkMode = true
      this.dedup_results.forEach(group=>{
        let obj ={"timerange":group.timerange,"fields":group.fields,"status":group.status,"alertCount":group.alertCount}
        this.exemptedGroups=[]
        this.multiSelect=[]

        // if(this.checkboxCheck(group)){
        // if(group.checked){
        // }else{
        //   this.multiSelect.push(obj)
        // }

        group.checked = true

        // let baseObj = {"alert_info":{"alertId":this.alertvarservice.dedupData.alertId,"dedup":[]}}
        
      })
      let baseObj = this.buildActionPostreqObjStruct()
        baseObj.alert_info.dedup=this.multiSelect
        baseObj.alert_info.exemptedGroups = this.exemptedGroups
        baseObj.alert_info["bulk_action"]=true
        baseObj.alert_info["timerange"]=this.toDate(this.alertvarservice.alertTimeFilter.value)
        baseObj["totalCount"]=this.multiSelect.length ? this.multiSelect.length :this.dedup_results.length
        this.multi_data = baseObj  
        
    }else{
      this.bulkMode = false
      this.multiSelect=[]
      this.exemptedGroups=[]
      this.dedup_results.forEach(group=>{
        group.checked = false
      })
      // let baseObj = {"alert_info":{"alertId":this.alertvarservice.dedupData.alertId,"dedup":[]}}
      let baseObj = this.buildActionPostreqObjStruct()
      baseObj.alert_info.dedup=this.multiSelect
      baseObj.alert_info.exemptedGroups = this.exemptedGroups
      baseObj.alert_info["bulk_action"]=false
      baseObj.alert_info["timerange"]=this.toDate(this.alertvarservice.alertTimeFilter.value)
      baseObj["totalCount"]=this.multiSelect.length ? this.multiSelect.length :this.dedup_results.length
      this.multi_data = baseObj  

    }

    // if(this.multiSelect.length >= 2){
    //   this.bulkMode = true
    // }else{
    //   this.bulkMode = false
    // }

  })

  this.itemperpage.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(val=>{
    this.pagenumber=1
    this.handleintelpagination()
  })

}

fieldsClick(field){
  // console.log(field)
  let exist =false
  if(this.selected_fields.length){
    this.selected_fields.forEach(val=>{
      if(val.disp == field.disp){
        exist = true
      }
    })
  }
  if(!exist){
    this.selected_fields.push(field)
  }else{
    this.removeFields(field)
  }
  
}

fieldsCheck(field){
  let exist = false
  this.selected_fields.forEach(val=>{
    if(val.disp == field.disp){
      exist = true
    }
  })
  return exist
}

removeFields(field){
  let index = this.selected_fields.findIndex(val=> val.disp == field.disp)
  this.selected_fields.splice(index,1)
}

removeAll(){
  this.selected_fields=[]
}

getTimeDisp(value){
  // console.log(value)
  let disp=""
  this.alertvarservice.dedup_time_data.forEach(val=>{
    if(val.value == value){
      // console.log(val.disp)
      disp = val.disp
    }
  })
  return disp
}

getActionDisp(value){
  let disp =""
  Object.keys(this.sharedservice.actions.actions).forEach(val=>{
    if(val == value.toString()){
      disp = this.sharedservice.actions.actions[val].disp
    }
  })
  return disp
}



toDate(metaDate: any) {
  let date=[this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[0]).format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[1]).format('YYYY-MM-DD HH:mm:ss')]
  return date
}

open_actionPanel(index,group){
// console.log(group)
  // let obj = {"alert_info":{"alertId":this.alertvarservice.dedupData.alertId,"dedup":[]}}
  let obj = this.buildActionPostreqObjStruct()
  if(this.active_panel == index){
    this.active_panel=null
  }else{
    
    let groupObj={"fields":group.fields,"status":group.status,"timerange":group.timerange}
    obj.alert_info.dedup.push(groupObj)

    this.alert_dedup_data=obj
    this.active_panel=index
  }

  // console.log(index,this.active_panel)
  
}


// async acknowledgeClick(index,group){

//   this.openEditPopup(this.actionpanel,index,group)
// }

actionClick(index,group,action){
  this.openEditPopup(this.actionpanel,index,group,action)
}

buildActionPostreqObjStruct(){
  return {
    "alert_info":{
      "alertId":this.alertvarservice.dedupData.alertId,
      "assigned_user":[this.sharedservice.getCurrentUserId()],
      "status":this.alertvarservice.getStateFilterValue(),
      "dedup":[],
      "exemptedGroups":[]
    }
  }
}

openEditPopup(template,index,group,action) {
  // this.alertvarservice.dedupId = alertId
  const dialogRef: MatDialogRef<any> = this.matdialog.open(template, {
    minWidth: '35vw',  
    // minHeight: '30vh',
    // width:'30vw',
    // height:'30vh',
    disableClose:true
    // panelClass: 'resizable-dialog'
  });

  this.dialogRef = dialogRef

  this.alertvarservice.actionPanel = dialogRef

  this.setActionInput = {"group":group,"action":action,"alertId":this.alertvarservice.dedupData.alertId}


  // this.alertvarservice.dedupDialogRef = dialogRef

  this.dialogRef._afterClosed.subscribe(val=>{
// console.log(index,val)
// console.log(this.alertvarservice.alertStateFilter.value)

    if(val?.post_status == 1){
      if(val?.refresh_status){
        this.refreshDedup = true;
        this.applyDedup()
      } else {
        if([3,5,6].includes(action.value) || (!this.alertvarservice.alertStateFilter.value.includes(action.value) && this.alertvarservice.alertStateFilter.value[0] != 'all')){
        // console.log("=--> ",this.dedup_results)
        // this.dedup_results.splice(index,1)
        // console.log("=----> ",this.dedup_results)
        this.applyDedup()
        this.deletedRecordCount += 1;
        }else{
// console.log(this.dedup_results[index])
          this.dedup_results[index].status = action.value
        }
      }
      
    }
    // this.alertvarservice.dedupData = {"alertId":"","status":0}
    this.setActionInput={}
// console.log("Close")
  })

}

getSelectedAlertCount(){
  let count = 0


  if(this.multiSelect.length){
    this.multiSelect.forEach(val=>{
      count +=val.alertCount
    })
  }else{
    let exemptCount = 0 
    this.exemptedGroups.forEach(val=>{
      exemptCount += val.alertCount
    })
    this.dedup_results.forEach(val=>{
      count += val.alertCount
    })

  }

  return count

}

async acknowledgeClick(index,group){
  let req = {"alertId":this.alertvarservice.dedupData.alertId,"dedup":[]}
  // let obj = {"alert_info":{"alertId":this.alertvarservice.dedupData.alertId,"dedup":[]}}
  let obj = this.buildActionPostreqObjStruct()
    
    let groupObj={"fields":group.fields,"status":group.status,"timerange":group.timerange}
    req.dedup.push(groupObj)
    obj.alert_info.dedup.push(groupObj)

    this.alert_dedup_data=obj
    
    req["action"]=1
    req["priority"]=null
    req["reason"]=null
    req["reassign"]=null
    this.mat_fields_spinner=true
    await this.alertservice.updateAlertActionPost.postrequest(req).then((val:any)=>{
// console.log(val)
      if(val.status){
        this.alert_dedup_data["alert_info"]["dedup"].forEach(dat=>{
          dat.status = 1
        })
        this.updateStatus(index,1)
        this.active_panel  = null
// console.log("After API =----> ",this.alert_dedup_data)
        this.active_panel=index
        // this.applyDedup()
        // this.open_actionPanel(index,group)
      }
      this.mat_fields_spinner=false
    }).catch(err=>{
      this.mat_fields_spinner=false
// console.log(err)
    })
}

updateStatus(index,status){
  this.dedup_results[((this.pagenumber-1)*this.itemperpage.value)+index].status = status
}


async updateAction(event){
// console.log(event)
  if(event.event == "cancel"){
    this.active_panel  = null
    this.bulkMode = false
    this.selectAll.setValue(false)
  }else{
    this.mat_fields_spinner=true
    await this.alertservice.updateAlertActionPost.postrequest(event.request).then((val:any)=>{
// console.log(val.status)
      if(val?.status == 1){
        this.selectAll.setValue(false)
        this.applyDedup()
        // this.alertvarservice.createtoastmsg({
        //   "type":"success", 
        //   "text":this.alertvarservice.toaster_message_alerts.success.update_action
        // })
        if(!this.bulkMode){
          this.alertvarservice.actionUpdateToasterMsg(event.request.action,val.updated_rows,1,false)
          this.alert_dedup_data["alert_info"]["dedup"].forEach(dat=>{
          dat.status = event.request.action
        })

        this.updateStatus(this.active_panel,event.request.action)
        this.active_panel  = null
        }else{
          this.alertvarservice.actionUpdateToasterMsg(event.request.action,val.updated_rows,this.getSelectedAlertCount(),true)
          this.bulkMode = false
          this.multiSelect=[]
          this.exemptedGroups=[]
        }
        
        
// console.log("After API =----> ",this.alert_dedup_data)
// console.log(this.multiSelect)
      }else{
        this.alertvarservice.createtoastmsg({
          "type":"error", 
          "text":this.alertvarservice.toaster_message_alerts.error.update_action
        })
      }
      this.mat_fields_spinner=false
    }).catch(err=>{
// console.log(err)
      this.mat_fields_spinner=false
    })
  }
  

}

addChecked(){
  this.dedup_results.forEach(val=>{
    val["checked"] = false
  })
}

async applyDedup(){
  let req ={}
  // req["alertId"]=this.alertvarservice.dedupId
  req["alertId"]=this.alertvarservice.dedupData.alertId
  // req["status"]=this.alertvarservice.dedupData.status
  // req["status"]=0
  req["timewindow"]=this.alertvarservice.dedup_time.value
  // req["timerange"] = [
  //   "2025-10-28 18:30:00",
  //   "2026-08-24 08:33:05"
  // ]
  // req["page"] = this.pagenumber
  // req["itemperpage"] = this.itemperpage.value
  req["timerange"]=this.toDate(this.alertvarservice.alertTimeFilter.value)
  let arr=[]
  this.selected_fields.forEach(val=>{
    arr.push(val.disp)
  })
  req["fields"]=arr

  req["status"]=this.alertvarservice.getStateFilterValue()

  req["assigned_user"] =[this.sharedservice.analystlist.find(item => item.disp === this.sharedservice.userName)?.value ?? 0]

  if(getObjectDiff(this.dedupReq,req).status == 'equal'){
    this.showApply = false
  }else{
    this.showApply = true
  }

  if(this.showApply && this.alertvarservice.dedup_time.value){
// console.log("Post request =----> ",req)

    this.mat_fields_spinner=true
    this.deletedRecordCount = 0;

    await this.alertservice.dedupGet.postrequest(req).then(val=>{
// console.log(val)
      this.dedup_results=val
      this.multiSelect=[]
      this.exemptedGroups=[]
      this.selectAll.setValue(false)
      this.addChecked()
      this.handleintelpagination()
      this.mat_fields_spinner=false

      

    }).catch(err=>{
// console.log(err)
      this.mat_fields_spinner=false
    })
    

   
  }

  this.dedupReq = req
}


getApplicableActions(status){
  let actions = this.sharedservice.actions.actions

  let actionObj={}

  Object.keys(actions).forEach(key=>{
    if(status == key && status !=0){
      actions[key].next.forEach(val=>{
        actionObj[val]=actions[val]
      })
    }else if(status == 0){
      Object.keys(actions).forEach(dat=>{
        if(!actions[dat].isDefault){
          actionObj[dat]=actions[dat]
        }
      })
    }
  })
  return actionObj? actionObj : []
}


originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
  return 0;
}

handleintelpagination() {
  const pagelength =
    Math.ceil(this.dedup_results.length / this.itemperpage.getRawValue());
  if (pagelength) {
    this.pagelength = pagelength;
  } else {
    this.pagelength = 1;
  }
  if (
    (this.pagenumber > this.pagelength)
  ) {
    this.pagenumber = this.pagelength;
  }
  // console.log("intelPagination")
  // this.mat_spinner_create_state=false
}

intelpaginationTable_click(direction: number){
  if (!this.mat_fields_spinner) {
    let pagevalue = this.pagenumber;
    if (direction == -1) {
      if (pagevalue > 1) {
        this.pagenumber = this.pagenumber - 1;
      }
    } else {
      if (pagevalue < this.pagelength) {
        this.pagenumber = this.pagenumber + 1;
        this.pagenumber = Math.floor(((this.pagenumber - 1) * this.itemperpage.getRawValue() - this.deletedRecordCount) / this.itemperpage.getRawValue()) + 1;
      }
    }
    this.active_panel=null
  }
}


close(){
  
  if(!this.dedup_results.length && this.showApply){
    this.alertvarservice.dedupDialogRef.close("refresh")
  }else{
    this.alertvarservice.dedupDialogRef.close()
  }
}


ngOnDestroy(){
  this.$destroy.next()
  this.$destroy.unsubscribe()
}
  
}
